import { Text, Heading, LiliButton, FontWeight } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { useBlocker } from '@tanstack/react-router';
import CheckmarkIcon from '@Assets/icons/checkmark.svg';
import { useBoundStore } from '@Store/useBoundStore';
import { EnvironmentVariables, getEnvironmentVariable } from '@Services/env/environment.service';
import { getUserFirstName } from '@Services/utils/utils';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';

export const InviteTeamMemberFinished = () => {
  const { authorizedUserFullName } = useBoundStore.getState().authOnboardingSlice;
  const { t } = useTranslation('inviteTeamMember');
  const { firstName } = useBoundStore.getState()?.customer?.customerData || '';
  const userFirstName = firstName || getUserFirstName(authorizedUserFullName);
  const handleGoToAccount = () => {
    const redirectUrl = getEnvironmentVariable(EnvironmentVariables.VITE_APP_DEEPLINK);
    window.location.href = redirectUrl;
  };
  useBlocker({
    shouldBlockFn: ({ next }) => {
      if (
        next.routeId === routesModel[RoutesMap.SET_PASSWORD].path ||
        next.routeId === routesModel[RoutesMap.AUTH_USER_HOME_ADDRESS].path
      ) {
        return true;
      }
      return false;
    },
    enableBeforeUnload: false,
  });

  return (
    <div className='flex flex-col items-center justify-center w-full min-h-screen bg-surface-primary-bw-02'>
      <div className='flex flex-col items-center w-[468px] p-[32px] bg-surface-primary-bw-00 outline-outline-primary-bw-03 rounded-[12px] shadow-sm'>
        <img
          src={CheckmarkIcon}
          alt={t('inviteTeamMemberFinished.checkmarkAlt')}
          className='w-[88px] h-[88px] mb-[24px]'
        />

        <div className='flex flex-col text-center w-full items-center mb-[8px]'>
          <Heading.H7 fontWeight={FontWeight.SEMIBOLD}>
            {t('inviteTeamMemberFinished.welcomeMessage', { firstName: userFirstName })}
          </Heading.H7>

          <Text.H10 className='text-text-main-secondary mb-[48px]'>
            {t('inviteTeamMemberFinished.accessMessage')}
          </Text.H10>

          <LiliButton
            id='go-to-account-button'
            title={t('inviteTeamMemberFinished.goToAccount')}
            onClick={handleGoToAccount}
          />
        </div>
      </div>
    </div>
  );
};

export default InviteTeamMemberFinished;
